"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareWindow = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const backendImport_1 = require("@front/backendImport");
const client_1 = require("@rws-framework/client");
const component_1 = require("@front/layouts/default-layout/component");
//@ts-ignore                
let rwsTemplate = T.html `<div id="share-window">
    <button class="btn btn-primary" @click="${(x) => x.toggleOpen()}"><i class="simple-icon-share"></i>
        ${'app.share'.t()}</button>
</div>
${(0, fast_element_1.when)(x => x.open, (0, fast_element_1.html) `<rws-modal name="share_modal" header="modal.share.title" centerTop="true">
    <div id="share_modal_container">
        <h3>${'app.share_link'.t()}:</h3>
        <p class="preview">
            <a class="share-link" target="_blank" href="${x => x.printLink()}">${x => x.printLink()} <i class="simple-icon-share"></i></a>
        </p>
        
        ${(0, fast_element_1.when)(x => x.isConversationCreator, (0, fast_element_1.html) `
            <h3>${'app.co_share'.t()}:</h3>
            <user-search-component hasLabel="false" :selectedUsers="${x => x.mappedUsers}" :onPick="${x => x.userSelected.bind(x)}"></user-search-component>
        `)}
    </div>
</rws-modal>`)}`;
require("./styles/layout.scss");
const styles = T.css `.preview {
  padding: 1rem;
  border: 1px solid #ddd;
  border-radius: 0.25rem;
  background-color: #f9f9f9;
}

#share_modal_container {
  min-height: 60vh;
}`;
const shadowOptions = { "mode": "open" };
let ShareWindow = class ShareWindow extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.open = false;
        this.convo = null;
        this.mappedUsers = [];
    }
    async connectedCallback() {
        await this.getConvo();
        this.addEventListener('rws_modal:share_modal:close', () => {
            this.open = false;
        });
        super.connectedCallback();
    }
    async getConvo() {
        if (!this.convoUid)
            return;
        try {
            const response = await this.apiService.back.get('conversation.share', {
                routeParams: { uid: String(this.convoUid) }
            });
            this.convo = response.data.conversation;
            this.mappedUsers = this.convo.selectedUsers || [];
        }
        catch (e) {
            console.error('Error fetching conversation in share window:', e);
        }
    }
    toggleOpen() {
        this.open = !this.open;
    }
    printLink() {
        if (!this.convoUid)
            return '';
        return `${this.config.get('backendUrl')}/share/${this.convoUid}`;
    }
    get isConversationCreator() {
        var _a;
        if (!this.convo || !component_1.DefaultLayout.USER) {
            return false;
        }
        return ((_a = this.convo.user) === null || _a === void 0 ? void 0 : _a.id) === component_1.DefaultLayout.USER.id;
    }
    async userSelected(pickedUsers) {
        console.log(this.convo);
        await this.apiService.back.post('conversation.add_share_user', {
            convoId: this.convo.id,
            users: pickedUsers.map(user => user.id)
        });
        await this.getConvo();
    }
};
exports.ShareWindow = ShareWindow;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ShareWindow.prototype, "open", void 0);
__decorate([
    client_1.attr,
    __metadata("design:type", Object)
], ShareWindow.prototype, "convoUid", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof backendImport_1.IConversation !== "undefined" && backendImport_1.IConversation) === "function" ? _a : Object)
], ShareWindow.prototype, "convo", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ShareWindow.prototype, "mappedUsers", void 0);
exports.ShareWindow = ShareWindow = __decorate([
    (0, client_1.RWSView)('share-window', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], ShareWindow);
ShareWindow.defineComponent();
